import { useQuery } from '@tanstack/react-query';

import { getHealthieUser } from '../useGetUser';

const getUpcomingAppointments = (healthieUserId: string) => {
  return fetch(
    `/api/healthie/provider/upcoming-appointments?healthieUserId=${healthieUserId}`,
  ).then((appointmentResponse) => appointmentResponse.json());
};

const getUserAndThenAppointments = () =>
  getHealthieUser().then(({ healthieUserId }) =>
    getUpcomingAppointments(healthieUserId),
  );

export const useGetUpcomingAppointments = () =>
  useQuery({
    queryKey: ['healthieUpcomingAppointments'],
    queryFn: getUserAndThenAppointments,
  });
